import BulkMetaWhatsAppCampaignForm from "./Meta";

import { useWhatsappConfiguration } from "V2.0/HomePages/Integrations/Whatsapp/models/useWhatsappConfiguration";

import useMcubeEngageConfiguration from "V2.0/HomePages/Integrations/Communications/Whatsapp/MCubeEngage/useMCubeEngageConfiguration";
import BulkMCubeEngageWhatsappCampaignForm from "./MCubeEngage";

export default function BulkWhatsAppCampaignForm(props) {
  const { fromNumber, workspaceId } = props;

  const { whatsappConfiguration } = useWhatsappConfiguration(workspaceId);

  const { mcubeEngageConfiguration, isConfigured: isMCubeEngageConfigured } =
    useMcubeEngageConfiguration(workspaceId);

  function isNumberFromWhatsappConfiguration() {
    const { phoneNumberIds } = whatsappConfiguration.data;

    if (phoneNumberIds.includes(fromNumber)) {
      return true;
    }

    return false;
  }

  function isNumberFromMCubeConfiguration() {
    const phoneNumbers = mcubeEngageConfiguration.phoneNumbers ?? [];

    if (phoneNumbers.includes(fromNumber)) return true;

    return false;
  }

  if (isMCubeEngageConfigured && isNumberFromMCubeConfiguration()) {
    return <BulkMCubeEngageWhatsappCampaignForm {...props} />;
  }

  return <BulkMetaWhatsAppCampaignForm {...props} />;
}
